import React from 'react'
import RichText from '@/ui/components/RichText'
import type { LinkCardBlock as LinkCardBlockProps } from '@/payload-types'
import { AllPages } from '../RenderBlocks'
import { Card } from '@/ui/components/Card'
import { CardType } from '@/ui/components/Card/types'
import { Title } from '@/ui/components/Title'
import { localizedHref } from '@/utils/localizedHref'


interface ExtendedLinkCardBlockProps extends LinkCardBlockProps {
  showLinkIcon?: boolean
  hasWhiteBg?: boolean
  sizes?: 'sm' | 'md'
  showArrowIcon?: boolean
  locale?: string
}

export const LinkCardBlock: React.FC<ExtendedLinkCardBlockProps> = ({
  title,
  titleHierarchy,
  text,
  linkCards,
  showLinkIcon = true,
  hasWhiteBg = true,
  sizes = 'md',
  showArrowIcon = true,
  locale = 'en',
}) => {
  return (
    <div>
      {title && (
        <Title
          title={title}
          hierarchy={titleHierarchy}
        />
      )}
      {text && (
        <RichText
          data={text}
          enableGutter={false}
          className={`!text-body-M-regular text-text-base mb-10`}
          enableProse={true}
        />
      )}
      <div className={`flex flex-col gap-2`}>
        {linkCards?.map((card, index) => {
          const cardValue = card.value as AllPages
          return (
            <Card
              key={index}
              type={CardType.Link}
              title={cardValue?.title}
              href={localizedHref(cardValue?.path, locale)}
              hasWhiteBg={hasWhiteBg}
              showLinkIcon={showLinkIcon}
              sizes={sizes}
              showArrowIcon={showArrowIcon}
            />
          )
        })}
      </div>
    </div>
  )
}
